// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-row.wrapper {
  align-items: center;
  padding: 10px 20px;
  margin-inline: 10px;
  box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);
  background: url('sanifair_background.png') no-repeat center center/100% 100%;
}
ion-row.wrapper ion-icon {
  margin: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
ion-row.wrapper.active {
  padding: 0;
}
ion-row.wrapper.inactive {
  height: auto;
  padding: 8px;
}
ion-row.wrapper p {
  margin: 0;
  line-height: 90%;
}
ion-row.wrapper .hint {
  margin-top: 6px;
  display: block;
}

.white-rounded-square {
  border-radius: 4px;
  color: var(--ion-color-secondary);
  fill: var(--ion-color-secondary);
}

ion-item {
  --border-radius: 15px;
  display: block;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
ion-item ion-label {
  color: var(--ion-color-primary);
  position: relative;
  margin-left: 20px;
  font-family: Tusker, sans-serif;
  font-size: 14px;
  line-height: 13px;
}
ion-item ion-input {
  color: var(--ion-color-primary);
  height: 0;
  font-family: AppFont, sans-serif;
}
ion-item ion-input.has-error {
  color: #EF5231;
}

.delete-promo {
  margin-left: 5px;
}

.submit-button {
  width: 40px;
  height: 40px;
}

.reg-row {
  width: 100%;
  color: var(--ion-color-secondary);
}
.reg-row__btn {
  flex: 1;
  border-radius: 5px;
  font-size: 16px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
}
.reg-row__btn:first-child {
  margin-right: 8px;
}
.reg-row__btn:last-child {
  margin-left: 8px;
}

ion-spinner {
  display: block;
  margin: 10px auto;
}

.promo-input {
  --padding-start: 20px;
}

.wraper_name {
  padding-bottom: 15px;
  border-bottom: 2.55px dotted white;
  margin-bottom: 10px;
}
.wraper_name .name {
  font-family: Tusker, sans-serif;
  font-size: 14px;
  line-height: 20px;
}
.wraper_name .discount {
  font-family: Tusker, sans-serif;
  font-size: 14px;
  line-height: 20px;
}

.promo-icon {
  width: 35px;
  height: 35px;
}

.promo-icon-button {
  height: 25px;
  width: 25px;
  padding: 5px;
}

.title {
  font-size: 14px;
  text-transform: uppercase;
  font-family: Tusker, sans-serif;
}

.dis {
  font-size: 14px;
}

.info {
  font-size: 12px;
}

.promo-label {
  padding: 2px 0px;
}

.add-icon {
  width: 40px;
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/promo-code/promo-code.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EAIA,+CAAA;EACA,4EAAA;AAFF;AAIE;EACE,SAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,UAAA;AAHJ;AAME;EACE,YAAA;EACA,YAAA;AAJJ;AAOE;EACE,SAAA;EACA,gBAAA;AALJ;AAQE;EACE,eAAA;EACA,cAAA;AANJ;;AAUA;EACE,kBAAA;EACA,iCAAA;EACA,gCAAA;AAPF;;AAUA;EACE,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAPF;AASE;EACE,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;AAPJ;AAUE;EACE,+BAAA;EACA,SAAA;EACA,gCAAA;AARJ;AAUI;EACE,cAAA;AARN;;AAaA;EACE,gBAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;AAVF;;AAaA;EACE,WAAA;EACA,iCAAA;AAVF;AAYE;EACE,OAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAVJ;AAYI;EACE,iBAAA;AAVN;AAaI;EACE,gBAAA;AAXN;;AAgBA;EACE,cAAA;EACA,iBAAA;AAbF;;AAgBA;EACE,qBAAA;AAbF;;AAgBA;EACE,oBAAA;EACA,kCAAA;EACA,mBAAA;AAbF;AAeE;EAEE,+BAAA;EACA,eAAA;EACA,iBAAA;AAdJ;AAiBE;EAEE,+BAAA;EACA,eAAA;EACA,iBAAA;AAhBJ;;AAmBA;EACE,WAAA;EACA,YAAA;AAhBF;;AAkBA;EACE,YAAA;EACA,WAAA;EACA,YAAA;AAfF;;AAmBA;EAEE,eAAA;EACA,yBAAA;EACA,+BAAA;AAjBF;;AAoBA;EACE,eAAA;AAjBF;;AAqBA;EACE,eAAA;AAlBF;;AAqBA;EACE,gBAAA;AAlBF;;AAoBA;EACE,WAAA;EACA,YAAA;AAjBF","sourcesContent":["ion-row.wrapper {\n  align-items: center;\n  padding: 10px 20px;\n  margin-inline: 10px;\n\n\n\n  box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);\n  background: url('../../../assets/tabilo/sanifair_background.png') no-repeat center center/ 100% 100% ;\n\n  ion-icon {\n    margin: 0;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &.active {\n    padding: 0;\n  }\n\n  &.inactive {\n    height: auto;\n    padding: 8px;\n  }\n\n  p {\n    margin: 0;\n    line-height: 90%;\n  }\n\n  .hint {\n    margin-top: 6px;\n    display: block;\n  }\n}\n\n.white-rounded-square {\n  border-radius: 4px;\n  color: var(--ion-color-secondary);\n  fill: var(--ion-color-secondary);\n}\n\nion-item {\n  --border-radius: 15px;\n  display: block;\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n\n  ion-label {\n    color: var(--ion-color-primary);\n    position: relative;\n    margin-left: 20px;\n    font-family: Tusker, sans-serif;\n    font-size: 14px;\n    line-height: 13px;\n  }\n\n  ion-input {\n    color: var(--ion-color-primary);\n    height: 0;\n    font-family: AppFont, sans-serif;\n\n    &.has-error {\n      color: #EF5231;\n    }\n  }\n}\n\n.delete-promo {\n  margin-left: 5px;\n}\n\n.submit-button {\n  width: 40px;\n  height: 40px;\n}\n\n.reg-row {\n  width: 100%;\n  color: var(--ion-color-secondary);\n\n  &__btn {\n    flex: 1;\n    border-radius: 5px;\n    font-size: 16px;\n    padding: 10px;\n    text-align: center;\n    cursor: pointer;\n\n    &:first-child {\n      margin-right: 8px;\n    }\n\n    &:last-child {\n      margin-left: 8px;\n    }\n  }\n}\n\nion-spinner {\n  display: block;\n  margin: 10px auto;\n}\n\n.promo-input {\n  --padding-start: 20px;\n}\n\n.wraper_name {\n  padding-bottom: 15px;\n  border-bottom: 2.55px dotted white;\n  margin-bottom: 10px;\n\n  .name {\n\n    font-family: Tusker, sans-serif;\n    font-size: 14px;\n    line-height: 20px;\n  }\n  \n  .discount {\n\n    font-family: Tusker, sans-serif;\n    font-size: 14px;\n    line-height: 20px;\n  }\n}\n.promo-icon {\n  width: 35px;\n  height: 35px;\n}\n.promo-icon-button {\n  height: 25px;\n  width: 25px;\n  padding: 5px;\n}\n\n\n.title {\n\n  font-size: 14px;\n  text-transform: uppercase;\n  font-family: Tusker, sans-serif;\n}\n\n.dis {\n  font-size: 14px;\n\n}\n\n.info {\n  font-size: 12px;\n\n}\n.promo-label {\n  padding: 2px 0px;\n}\n.add-icon {\n  width: 40px;\n  height: 40px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
